import React from 'react';
import CreateCustomerForm from "../components/CreateCustomerForm";
import styles from './InternalAdminTool.module.scss';

interface CreateCustomerViewProps {
    organisationId: string;
    corporateSite: string;
    onPipelineComplete?: (result: string | null) => void;
}

const CreateCustomerView: React.FC<CreateCustomerViewProps> = ({ organisationId, corporateSite, onPipelineComplete }) => {
    return (
        <div className={styles.createCustomerContainer}>
            <CreateCustomerForm
                organisationId={organisationId}
                corporateSite={corporateSite}
                showCreateAnother={false}
                onPipelineComplete={onPipelineComplete}
            />
        </div>
    );
};

export default CreateCustomerView;
